<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="8">
          <el-form-item label="房产" prop="propertyId">
            <el-select
              :value="propertyName"
              ref="propertySelectRef1"
              placeholder="请选择房产"
              style="width: 100%;"
            >
              <el-option :value="propertyName" :label="propertyName">
                <el-tree
                  ref="propertyTreeRef1"
                  node-key="id"
                  :props="treeProps"
                  :load="lazyLoadPropertyTree"
                  lazy
                  @node-click="propertyNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="费项类型" prop="feeType">
            <el-select v-model="query.feeType" placeholder="请选择">
              <el-option
                v-for="item in feeTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="账单月份" prop="feeCycleNo">
            <el-date-picker
              v-model="feeCycleNo"
              :clearable="false"
              type="month"
              placeholder="账单月份"
              @change="feeCycleChange"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <!--<el-col :span="4">feeCycleNo
          <el-form-item label="账单起期" prop="billDateFrom">
            <el-date-picker
              v-model="billDateFrom"
              type="month"
              placeholder="开始月份"
              @change="billDateFromChange"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="账单止期" prop="billDateTo">
            <el-date-picker
              v-model="billDateTo"
              type="month"
              placeholder="结束月份"
              @change="billDateToChange"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>-->
        <el-col :span="4">
          <el-form-item label="缴费状态" prop="payType">
            <el-select v-model="query.payStatus" style="width: 100%;" clearable placeholder="请选择">
              <el-option
                v-for="item in payStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="未生成账单" prop="upbilled">
            <el-select v-model="query.unbilled" style="width: 100%;" clearable placeholder="请选择">
              <el-option
                v-for="item in unbilledList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="收费时间 从" prop="payDateRange">
            

            <el-date-picker
              style="width:42%;"
              v-model="query.payDateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payDateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" style="width: 100%;" clearable placeholder="请选择">
              <el-option
                v-for="item in payTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="应收金额">
            <el-input
              size="small"
              v-model="shouldPayAmount"
              class="self-input-red"
              ref="shouldPayAmount"
              @focus="blurThis('shouldPayAmount')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="实收金额">
            <el-input
              size="small"
              v-model="actualPayAmount"
              class="self-input-red"
              ref="actualPayAmount"
              @focus="blurThis('actualPayAmount')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            size = "small"
            icon="el-icon-search"
            @click="submitSearchForm"
            :disabled="loading"
            style="margin-left:15px"
          >搜索</el-button>
          <el-button icon="el-icon-delete" size = "small" @click="searchReset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="downloadTemplate"
          style="margin-left: 20px;"
          v-show="permissionList.downloadBtn"
        >下载模板
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          @click="openUploadForm"
          style="margin-left: 20px;"
          v-show="permissionList.uploadBtn"
        >导入清单
        </el-button>
        <!--        <el-button
          type="primary"
          size="small"
          icon="el-icon-finished"
          @click="generateEnergyBill"
          style="margin-left: 20px;"
          v-show="permissionList.createBtn"
          >生成账单
        </el-button>-->
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          style="margin-left: 20px;"
          plain
          v-show="permissionList.delBtn"
          @click="handleDelete"
        >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="exportEnergyBill"
          style="margin-left: 20px;"
          v-show="permissionList.exportBtn"
          hidden
        >导出账单
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-printer"
          @click="printData"
          style="margin-left: 20px;"
          hidden
        >打印
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="上传清单"
      :visible.sync="showUploadDialog"
      v-if="showUploadDialog"
      :modal-append-to-body="false"
      width="35%"
      height="500px"
      id="energy-upload"
    >
      <el-form ref="uploadForm" :model="upload" label-width="150px" :rules="uploadRules">
        <el-row>
          <el-col :span="20">
            <el-form-item label="费项类型" prop="feeType">
              <el-select
                v-model="upload.feeType"
                style="width: 100%;"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in feeTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="收费月份" prop="feeCycleNo">
              <el-date-picker
                style="width: 100%;"
                v-model="upload.feeCycleNo"
                type="month"
                format="yyyy-MM"
                placeholder="选择月"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="导入清单" prop="fileName">
              <el-upload
                accept=".xls, .xlsx"
                limit="1"
                style="display: inline-block; vertical-align: top;width: 100%"
                ref="upload"
                action=""
                :auto-upload="false"
                :http-request="uploadImg"
                :on-success="uploadImgSuccess"
                :on-change="loadJsonFromFile"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary">请选择文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px;">
          <el-col offset="16">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-check"
              @click="uploadBill"
              style="width: 72px; height: 36px;"
            >确认
            </el-button>
            <el-button
              size="small"
              @click="cancelUpload"
              icon="el-icon-close"
              style="width: 72px; height: 36px;"
            >取消
            </el-button>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-form>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {getToken} from '@/util/auth';
  import {
    add,
    remove,
    update,
    getDetail,
    getList,
    submitUploadBill,
    queryShortCode,
    createEnergyBill,
  } from '@/api/v4ward/energe/feeenergyuse';
  import {mapGetters} from 'vuex';
  import {getTreeChildrenPowerNode} from '@/api/v4ward/property/baseproperty';
  import {getDictionaryWithIntKey} from '../../../api/common';
  import func from '@/util/func';
  import axios from 'axios';

  export default {
    data() {
      return {
        form: {},
        query: {
          feeType: null,
          payDateFrom:'',
          payDateTo:'',
        },
        payDateRange: '',
        billDateFrom: '',
        billDateTo: '',
        feeCycleNo: '',
        shortCode: '',
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 80,
          tip: false,
          border: true,
          index: true,
          indexLabel: '序号',
          viewBtn: true,
          delBtn: false,
          selection: true,
          align: 'center',
          menu: true,
          menuWidth: 100,
          printBtn: true,
          dialogWidth: '50%',
          labelWidth: 120,
          column: [
            {
              label: '小区名称',
              prop: 'communityName',
              width: 150,
              overHidden: true,
              editDisabled: true,
            },
            {
              label: '房产名称',
              prop: 'roomName',
              width: 230,
              overHidden: true,
              editDisabled: true,
            },
            {
              label: '费项类型',
              prop: 'feeType',
              dataType: 'number',
              type: 'select',
              editDisabled: true,
              width: 98,
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=fee_energy_type',
            },
            {
              label: '年月',
              prop: 'feeCycleNo',
              width: 70,
              editDisabled: true,
            },
            {
              label: '计费方式',
              prop: 'energyPayType',
              type: 'select',
              editDisplay: false,
              props: {
                label: 'label',
                value: 'key',
              },
              dicData: [
                {label: '按单价', key: 1},
                {label: '按固定金额', key: 2},
                {label: '按阶梯价', key: 3},
              ],
            },
            {
              label: '单价(元)',
              prop: 'lockFlag',
              width: 50,
            },
            {
              label: '使用量',
              prop: 'pointsNumber',
              width: 70,
              editDisabled: true,
              /*formatter: (row,value,label,column)=>{
                return value < 0 ? '--':value;
              }*/
            },
            {
              label: '单位',
              prop: 'pointsRemark',
              hide: true,
              width: 50,
            },
            {
              label: '起码',
              prop: 'beginNumber',
            },
            {
              label: '止码',
              prop: 'endNumber',
            },
            {
              label: '导入金额(元)',
              prop: 'accountAmount',
            },
            {
              label: '账单金额',
              prop: 'shouldAmount',
              editDisplay: false,
            },
            {
              label: '实缴金额',
              prop: 'payAmount',
              editDisplay: false,
            },
            {
              label: '支付方式',
              prop: 'payType',
              type: 'select',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=pay_type',
              editDisplay: false,
            },
            {
              label: '支付时间',
              prop: 'payTime',
              type: 'date',
              format: 'yyyy-MM-dd',
              editDisplay: false,
            },
          ],
        },
        data: [],
        ////
        propertyName: '',
        treeProps: {
          //标题
          label: 'objectFullName',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'isLeaf',
          //本节点类型key值
          objectType: 'objectType',
          //本节点类型名
          objectTypeName: 'objectTypeName',
        },
        ////
        payStatusList: [
          {
            label: '已缴费',
            value: 1,
          },
          {
            label: '未缴费',
            value: 0,
          },
        ],
        unbilledList: [
          {
            label: '未生成',
            value: 1,
          },
        ],
        payTypeList: [],
        feeTypeList: [],
        //energyPayTypeList: [],
        shouldPayAmount: 0,
        actualPayAmount: 0,
        showUploadDialog: false,
        uploadRules: {
          feeType: [{required: true, message: '请选择账单费用种类', trigger: 'change'}],
          //energyPayType: [{ required: true, message: '请选择计费方式', trigger: 'change' }],
          fileName: [{required: true, message: '请选择账单文件', trigger: 'change'}],
          feeCycleNo: [{required: true, message: '请选账单月份', trigger: 'change'}],
        },
        upload: {
          fileName: '',
        },
        areaList: [],
      };
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.feeenergyuse_add, false),
          viewBtn: this.vaildData(this.permission.feeenergyuse_view, false),
          delBtn: this.vaildData(this.permission.feeenergyuse_delete, true),
          editBtn: this.vaildData(this.permission.feeenergyuse_edit, true),
          downloadBtn: this.vaildData(this.permission.feeenergyuse_download, true),
          uploadBtn: this.vaildData(this.permission.feeenergyuse_upload, true),
          printBtn: this.vaildData(this.permission.feeenergyuse_print, true),
          createBtn: this.vaildData(this.permission.feeenergyuse_create, true),
          exportBtn: this.vaildData(this.permission.feeenergyuse_export, true),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    mounted() {
      this.initAllSelectionList();

      this.InitBillDateRange();
    },
    methods: {
      InitBillDateRange() {
        this.billDateFrom = func.getCurrentMonth();
        this.billDateTo = this.billDateFrom;
        this.feeCycleNo = this.billDateFrom;
        //this.query.billDateFrom = this.billDateFrom.replace('-','');
        //this.query.billDateTo = this.billDateTo.replace('-','');
        this.query.feeCycleNo = this.billDateTo.replace('-', '');
        this.query.feeType = 8;
        this.payDateRange = [func.getCurrentMonthFirst(), func.getCurrentMonthLast()];
        this.query.payDateFrom = func.getCurrentMonthFirst() + ' 00:00:00.000';
        this.query.payDateTo = func.getCurrentMonthLast() + ' 23:59:59.999';
      },
      ///搜索
      querySearch(queryString, cb) {
        console.log('-----速记码-------' + queryString);
        // 调用 callback 返回建议列表的数据
        queryShortCode(queryString).then((data) => {
          console.log(JSON.stringify(data));
          cb(data.data);
        });
      },
      handleSelect(item) {
        console.log(JSON.stringify(item));
      },
      feeCycleChange(value) {
        this.query.feeCycleNo = this.getFeeCycle(value);
      },
      billDateFromChange(value) {
        if (!value) {
          delete this.query.billDateFrom;
        } else {
          this.query.billDateFrom = this.getFeeCycle(value);
        }
      },
      billDateToChange(value) {
        if (!value) {
          delete this.query.billDateTo;
        } else {
          this.query.billDateTo = this.getFeeCycle(value);
        }
      },
      blurThis(refName) {
        this.$refs[refName].blur();
      },
      ///
      uploadImg(f) {
        /*var compareName = this.getFileName(this.upload.feeType);
        if (this.upload.fileName.substring(0, 10) !== compareName.substring(0, 10)) {
          this.$confirm('所选文件名与类型相差太多，是否确认无误？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.uploadFile(f);
          });
        } else {
        }*/
        this.uploadFile(f);
      },
      uploadFile(f) {
        //this.loading = true;
        const formData = new FormData();
        formData.append('feeType', this.upload.feeType);
        //formData.append('energyPayType', this.upload.energyPayType);
        formData.append('feeCycleNo', this.getFeeCycle(this.upload.feeCycleNo));
        formData.append('file', f.file);
        submitUploadBill(formData)
          .then((response) => {
            if (response.code === 200) {
              this.$message.success('上传成功!');
              this.upload = {};
              this.refreshChange();
              this.showUploadDialog = false;
              this.loading = false;
            }
          }).catch(() => {
          f.onError();
          this.loading = false;
        });
      },
      getFeeCycle(date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        if (m < 10) {
          return y + '0' + m;
        } else {
          return y + '' + m;
        }
      },
      uploadImgSuccess(response, file, fileList) {
        // 缓存接口调用所需的文件路径
        console.log('文件上传成功');
        //  this.$message.success("上传成功!");
      },
      handleRemove(file, fileList) {
        console.log('移除文件...');
        console.log(file, fileList);
      },
      downloadTemplateBk() {
        if (!this.checkParam()) {
          return;
        }
        const fileName = this.getFileName(this.query.feeType);
        console.log('下载模板...');
        axios
          .get(
            '/api/energe/feeenergyuse/downTemplate?propertyId=' +
            this.query.propertyId +
            '&feeType=' +
            this.query.feeType,
            {responseType: 'blob'}
          )
          .then((res) => {
            let blob = new Blob([res.data], {type: 'application/download'});
            let downloadElement = document.createElement('a');
            downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
            downloadElement.download = fileName;
            downloadElement.click();
            window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
          })
          .catch((error) => {
            console.error(error);
          });
      },
      downloadTemplate() {
        if (!this.checkParam()) {
          return;
        }
        window.open(`/api/energe/feeenergyuse/downTemplate?Blade-Auth=${getToken()}&propertyId=` +
          this.query.propertyId +
          '&feeType=' +
          this.query.feeType,);
      },
      exportEnergyBill() {
        if (!this.query.propertyId) {
          this.$message.error('请选择房产!');
          return false;
        }
        if (!this.query.billDateFrom) {
          this.$message.error('请选择账单起期!');
          return false;
        }
        if (!this.query.billDateTo) {
          this.$message.error('请选择账单止期!');
          return false;
        }
        console.log('导出账单。。。');
      },
      checkParam() {
        if (!this.query.propertyId) {
          this.$message.error('请先选择房产!');
          return false;
        }
        if (!this.query.feeType) {
          this.$message.error('请先费项类型!');
          return false;
        }
        return true;
      },
      getFileName(feeType) {
        let fileName = '账单';
        if (feeType === 8) {
          fileName = '水费账单';
        } else if (feeType === 10) {
          fileName = '电费账单';
        } else if (feeType === 7) {
          fileName = '燃气账单';
        }
        let date = new Date();
        let year = date.getFullYear(); //获取完整的年份(4位)
        let month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        let day = date.getDate(); //获取当前日(1-31)
        return fileName + '-' + this.propertyName + '-' + year + '-' + month + '-' + day + '.xls';
      },
      openUploadForm() {
        console.log('打开上传表单...');
        this.showUploadDialog = true;
      },
      loadJsonFromFile(file, fileList) {
        this.upload.fileName = file.name;
      },
      uploadBill() {
        console.log('上传账单...');
        this.$refs['uploadForm'].validate((valid) => {
          if (valid) {
            this.$refs.upload.submit();
          }
        });
      },
      cancelUpload() {
        console.log('取消上传...');
        this.upload = {};
        this.showUploadDialog = false;
      },
      printData() {
        console.log('打印...');
      },
      generateEnergyBill() {
        var message = '确定生成所有账单？';

        /*      if (this.selectionList.length > 0) {
          message = '确认重新生成账单？'
        }*/
        this.$confirm(message, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            //return createEnergyBill(this.ids);
            this.loading = true;
            return createEnergyBill('');
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '能源账单生成完成!',
            });
            this.loading = false;
            this.$refs.crud.toggleSelection();
          })
          .catch((err) => {
            console.log('err:' + err);
            this.loading = false;
          });
      },
      submitSearchForm() {
        this.searchChange(this.query);
      },
      initAllSelectionList() {
        getDictionaryWithIntKey('pay_type').then((data) => {
          this.payTypeList = data.data;
        });
        getDictionaryWithIntKey('fee_energy_type').then((data) => {
          this.feeTypeList = data.data;
        });
        /*      getDictionaryWithIntKey('energy_fee_cal_type').then((data) => {
          this.energyPayTypeList = data.data;
        });*/
      },
      ////////////
      lazyLoadPropertyTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        console.log('lazyLoadPropertyAddParentNodeTree' + node.level);

        getTreeChildrenPowerNode({id: id, power: 1}).then(({data}) => {
          resolve(data);
          if (node.level === 0) {
            this.areaList = data;
            this.initProperty();
            this.onLoad(this.page);
          }
        });
      },
      initProperty() {
        if (this.areaList.length > 0) {
          this.propertyName = this.areaList[0].objectFullName;
          this.query.propertyId = this.areaList[0].id;
        }
      },
      propertyNodeTreeClick(node) {
        this.query.propertyId = node[this.treeProps.value];
        this.propertyName = node[this.treeProps.label];
      },

      ///////////////

      rowSave(row, loading, done) {
        add(row).then(
          () => {
            loading();
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(
          () => {
            loading();
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定删除未生成账单的数据?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail(this.form.id).then((res) => {
            let data = res.data;
            if (JSON.stringify(data) === '{}') {
              this.$message({
                type: 'warning',
                message: '账单已生成，不能修改!',
              });
            } else {
              this.form = data;
              done();
            }
          });
        }
        //done();
      },
      searchReset() {
        console.log("]]]]]]]");
        this.tool.clearObject(this.query);
        // this.query = {};
        this.initProperty();
        this.InitBillDateRange();
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = false;
        if (this.vdui.isEmpty((this.query.propertyId))) {
          return;
        }
        this.loading = true;
      

        getList(page.currentPage, page.pageSize, Object.assign(params, this.query))
          .then(res => {
            const data = res.data.pages;
            const amounts = res.data.amounts;
            this.shouldPayAmount = amounts.totalShouldAmount;
            this.actualPayAmount = amounts.totalPayAmount;
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>

<style scoped>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
    height: auto;
    max-height: 274px;
    line-height: 25px;
    padding-left: 10px;
    overflow: hidden;
    overflow-y: auto;
  }

  .self-input-red input.el-input__inner {
    color: red;
    font-size: 16px;
    background-color: #f3f3f3;
    text-align: center;
  }
</style>
